import React, { Component } from "react";
import { Styled } from "../../../toolkit/decorators/Artifact";
import InvitadoDetalle from "../../../types/InvitadoDetalle";
import { formatEnum } from "../../helpers/formatters";
import s from "./styles.scss";

interface Props {
  detalle: InvitadoDetalle;
}
interface State {}

@Styled(s)
export default class InvitadosDetalleInfo extends Component<Props, State> {
  render() {
    const invitado = this.props.detalle;

    return (
      <div className={`row ${s.details}`}>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Tipo</h5>
            {formatEnum(invitado.tipo)}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Estatus</h5>
            {formatEnum(invitado.estatus)}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Familiar</h5>
            {invitado.userColaborador || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Autorizó</h5>
            {invitado.userAutorizacion || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Empresa</h5>
            {invitado.empresa || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Tipo de Intercambio</h5>
            {formatEnum(invitado.tipoIntercambio) || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Inicio vigencia</h5>
            {invitado.fechaInicioVigencia || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Fin vigencia</h5>
            {invitado.fechaFinVigencia || "-"}
          </div>
        </div>
      </div>
    );
  }
}
